import history from 'common/history';
import { History } from 'history';
import { routerMiddleware } from 'react-router-redux';
import {
  applyMiddleware,
  compose,
  createStore,
  StoreEnhancerStoreCreator,
} from 'redux';
import thunk from 'redux-thunk';

import reducers, { State } from 'modules';
import { Store } from 'react-redux';
import { Action } from 'util/actions';
import { saveLastSession } from 'util/last-session';

type ReduxMiddleware = (store: Store<State>) => void;

interface StoreWithHistory {
  store: Store<State>;
  history: History;
}

export default (
  additionalMiddlewareFunctions?: ReduxMiddleware[],
): StoreWithHistory => {
  // Build the middleware for intercepting and dispatching navigation actions
  const middleware = routerMiddleware(history);

  // Prefer the newer Redux DevTools global, but fallback to the old one.
  const reduxDevTools =
    window.__REDUX_DEVTOOLS_EXTENSION__ || window.devToolsExtension;

  // Also apply our middleware for navigating
  const store = createStore(
    reducers,
    compose(
      applyMiddleware(thunk, middleware),
      __DEV__ && reduxDevTools
        ? reduxDevTools({
            serialize: {
              options: {
                function: (symbol: symbol) => symbol.toString(),
              },
            },
            // In the future this may be able to be removed if the serialize
            // object works as intended and correctly handles symbols.
            actionSanitizer: (action: Action<symbol, object>) => ({
              ...action,
              type: action.type.toString().replace(/Symbol\((.+)\)/, '$1'),
            }),
          })
        : (f: StoreEnhancerStoreCreator<object>) => f,
    ),
  ) as Store<State>;

  saveLastSession(store);

  if (Array.isArray(additionalMiddlewareFunctions)) {
    additionalMiddlewareFunctions.forEach((middlewareFunction) => {
      middlewareFunction(store);
    });
  }

  return { history, store };
};



// WEBPACK FOOTER //
// ./app/gamma/src/store.ts